import React from "react";
import { useSelector } from "react-redux";
import { removeCurrencySign, formatCurrency } from "../../../Constants/utils";
import { getDiscount } from "../../../Redux/features/Dashboard/Charts/discountChartSlice";
import { CommonChart } from "./CommonChart";

export const DiscountChart = ({
  merchantId,
  activeType,
  presentDate,
  discountChartInView,
  discountChartRef,
  selectedOutletIds = [],
}) => {
  const discountChart = useSelector((state) => state.discountChart);
  const chartKey = "discountChart";

  return (
    <>
      <CommonChart
        componentRef={discountChartRef}
        activeType={activeType}
        formatFunction={removeCurrencySign}
        presentDate={presentDate}
        // sliceCallback={getDiscount}
        sliceCallback={(data) => getDiscount({ data, isRuntime: false })}
        sliceCallbackRunTimeData={(data) =>
          getDiscount({ data, isRuntime: true })
        }
        yAxisText={"Metric (e.g., revenue in $)"}
        reduxState={discountChart}
        reduxStateKey={"discountData"}
        reduxStateTotalKey={"totalDiscount"}
        valueKey={"total_discount"}
        chartKey={chartKey}
        merchantId={merchantId}
        chartInView={discountChartInView}
        title={"Discounts Given (Amount)"}
        totalValueFunction={formatCurrency}
        selectedOutletIds={selectedOutletIds}
      />

      {/* <CommonChart
        componentRef={discountChartRef}
        activeType={activeType}
        formatFunction={removeCurrencySign}
        presentDate={presentDate}
        sliceCallback={getDiscount}
        yAxisText={"Metric (e.g., revenue in $)"}
        reduxState={discountChart}
        reduxStateKey={"discountDatanew"}
        reduxStateTotalKey={"totalDiscountnew"}
        valueKey={"total_discount_new"}
        chartKey={chartKey}
        merchantId={merchantId}
        chartInView={discountChartInView}
        title={"Discounts Given (Amount)    (OLD)"}
        totalValueFunction={formatCurrency}
      /> */}
    </>
  );
};
